import React from 'react';
import { ThemeProvider, Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { Outlet, useLocation } from 'react-router-dom';
import withClearCache from './ClearCache';
import useCheckConnection from './hooks/useCheckConnection';
import NoInternetConnection from './components/NoInternetConnection';
import './App.scss';
import 'react-toastify/dist/ReactToastify.css';

const ClearCacheComponent = withClearCache(MainApp);

let isOnlineApp = false;

function App() {
  const { isOnline } = useCheckConnection();
  isOnlineApp = isOnline;

  return <ClearCacheComponent />;
}

const RenderContent = () => {
  return (
    <ThemeProvider breakpoints={['xs', 'sm', 'md']}>
      <Container fluid className="zeropm">
        <Outlet context={[]} />
        <ToastContainer theme="colored" />
      </Container>
    </ThemeProvider>
  );
};

function MainApp() {
  const location = useLocation();
  const pathname = location.pathname;
  const isHome = pathname === '/home';

  return (
    <div>
      <div className={isOnlineApp || isHome ? 'd-block' : 'd-none'}>
        <RenderContent />
      </div>
      <div className={isOnlineApp ? 'd-none' : 'd-block'}>
        <NoInternetConnection />
      </div>
    </div>
  );
}

export default App;
